import { Container } from "react-bootstrap"
import { Route, Switch, useRouteMatch } from "react-router-dom";
import AddPatient from "./patient/AddPatient";
import ListPatient from "./patient/ListPatient";
import MisCitas from "./patient/MisCitas";
import MisRespuestaUsuario from "./patient/MisRespuestaUsuario";
import Trazabilidad from "./Trazabilidad";

function PatientIndex(){
    let {path, url} = useRouteMatch();

    return (
        <Container fluid className="my-5">
            <Switch>
                <Route exact path={path}><ListPatient url={url}/></Route>
                <Route exact path={`${path}/create`}><AddPatient/></Route>
                <Route exact path={`${path}/appointments/:id`}><MisCitas imPaciente={false}/></Route>
                <Route exact path={`${path}/misrespuestas/:id`}><MisRespuestaUsuario /></Route>
                <Route exact path={`${path}/trazabilidad/:id`}><Trazabilidad paciente={true}/></Route>
            </Switch>            
        </Container>
    )
}

export default PatientIndex